import { colors } from "assets/styles/colors";
import { Grid } from "assets/styles/globalStyles";
import { FontSizes } from "utils/enums";
import styled from "styled-components";


export const HeaderOuter = styled.div`
        width:100%;
        padding:30px;
        position: fixed;
        top: 0;
        z-index:11;
        .__drawer{
            display: flex;
            flex-direction:column;
            gap:25px;
        }
  `;
export const DrawerItems = styled.div`
      display: flex;
      flex-direction:column;
      gap:15px;
      a{
        color:#000;
        font-size:16px;
      }
      .active {
        font-weight: 600;
        color: #dab2ff;
    }
  
`;

export const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff2e;
    padding: 15px 40px;
    border-radius: 140px;
    color: #fff;
    backdrop-filter: blur(10px);

    button{
        color: #fff;
        border: none;
        background: #794BA3;
        font-weight: 700;
        border-radius: 47px;
        font-size: 17px;
        height: 40px;
        width: 41px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

  `;

export const TopMenu = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
        a{
            color:#fff;
            font-size:20px;
        }
        .active{
            font-weight:600;
            color:#dab2ff
        }
`;

export const LogoText = styled.a`
    font-size: 20px;
    font-weight: 600;
    color:#fff !important;
    display:flex;
    gap:10px;
    align-items:center;
    a{
        color:#fff !important;
    }
}
`